import { useURLFilterState } from '@client/hooks/useURLFilterState';

/**
 * Filter keys configuration for active substance search
 * @type {string[]}
 */
const ACTIVE_SUBSTANCE_FILTERS = [
  'names',
  'cas_numbers', 
  'cultures',
  'activity_sectors',
  'cultures_practices',
  'chemical_families',
  'pesticide_groups',
  'pesticide_categories',
  'pesticide_types',
  'acute_toxicity',
  'long_term_effects',
  'fish_or_daphnia',
  'birds',
  'bees',
  'persistence',
  'leaching_potential',
];

/**
 * Specific hook for active substance filtering with URL synchronization
 * Manages filter state and URL synchronization for active substance search
 * @returns {Object} Filter state and methods for active substance search
 */
export const useActiveSubstanceFilters = () => {
  return useURLFilterState(ACTIVE_SUBSTANCE_FILTERS, {
    defaultPagination: { page: 1, size: 20 },
    throttleMs: 300,
    clearOnDefault: true,
  });
};
